import { zitoneoRoutes } from './zitoneoRoutes';

export interface QuickAccessItem {
    label: string;
    headerLabel?: string;
    icon: string;
    color: string;
    route: string;
}

/**
 * Builds the hotel presentation quick-access destinations.
 * @param hotelId Hotel identifier used to create the destination routes.
 * @param firstRoomId Identifier of the first room, if the hotel has one.
 * @returns The available quick-access links for the hotel.
 */
export const getHotelQuickAccessItems = (
    hotelId: string,
    firstRoomId = ''
): QuickAccessItem[] => {
    const items: QuickAccessItem[] = [
        {
            label: 'edit_services',
            headerLabel: 'edit',
            icon: 'Edit',
            color: 'green',
            route: zitoneoRoutes.HOTEL_EDITOR_HOTEL(hotelId),
        },
        ...(firstRoomId
            ? [
                  {
                      label: 'edit_rooms',
                      icon: 'Edit',
                      color: 'blue',

                      route: zitoneoRoutes.HOTEL_EDITOR_ROOM(
                          hotelId,
                          firstRoomId
                      ),
                  },
              ]
            : []),
        {
            label: 'add_images',
            icon: 'Image',
            color: 'purple',
            route: zitoneoRoutes.HOTEL_EDITOR_HOTEL(hotelId, 'images'),
        },
        {
            label: 'preview',
            headerLabel: 'preview',
            icon: 'Language',
            color: 'pink',
            route: zitoneoRoutes.HOTEL_PREVIEW(hotelId),
        },
        {
            label: 'settings',
            headerLabel: 'settings',
            icon: 'SettingsOutlined',
            color: 'grey',
            route: zitoneoRoutes.HOTEL_SETTINGS(hotelId),
        },
    ];

    return items;
};
